import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router.js'
import store from './store'
import LayoutDefault from './layouts/LayoutDefault.vue'
import axios from "axios";

Vue.prototype.$http = axios
Vue.config.productionTip = false
Vue.config.devtools = false

Vue.config.performance = true
Vue.component('default-layout', LayoutDefault)

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
